



























import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { TokenCategoriesEnum } from "@/lib/enum/templateEnums/tokenCategories.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IAppraisal } from "@/models/appraisal.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { IReport } from "@/models/report.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

@Component({
  components: { PreselectTemplateCard, ConfirmActionDialog },
  filters: {}
})
export default class ReportAppraisalEstimateSendDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: false }) appraisal!: IAppraisal;
  @Prop({ default: PreselectTemplateKeysEnum.REQUEST_APPRAISAL_MAIL }) templateKey!: PreselectTemplateKeysEnum;
  @Prop() repairEstimate?: IRepairEstimate;
  @Prop() report?: IReport;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  get title() {
    if (this.appraisal) {
      return $t("components.PartnerReportDetail.repair.ReportAppraisalRequestDialog.title", {
        title: this.report?.title || ""
      });
    }

    if (this.repairEstimate) {
      return $t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.title", {
        title: this.report?.title || ""
      });
    }

    return "";
  }

  get refs() {
    if (!this.appraisal && !this.repairEstimate) {
      return [];
    }
    let resource = undefined;
    if (this.appraisal) {
      resource = ResourceEnum.APPRAISAL;
    }

    if (this.repairEstimate) {
      resource = ResourceEnum.REPAIR_ESTIMATE;
    }

    return [
      { refId: this.entity.id, refType: resource },
      { refId: this.entity.reportId, refType: ResourceEnum.REPORT }
    ];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get vehicle() {
    return this.report?.vehicle;
  }

  get entity() {
    return this.repairEstimate || this.appraisal;
  }

  get context() {
    const firstSharedContent = this.entity?.sharedContent?.[0];
    return {
      [TokenCategoriesEnum.PARTNER]: this.partner,
      [TokenCategoriesEnum.REPORT]: this.report,
      vehicle: this.vehicle,
      [TokenCategoriesEnum.APPRAISAL]: this.appraisal,
      [TokenCategoriesEnum.ESTIMATE]: this.repairEstimate,
      [TokenCategoriesEnum.URL]: {
        sharing: firstSharedContent?.url ?? ""
      }
    };
  }

  get myUserId() {
    return UserModule.userId;
  }

  async sendMail() {
    await this.templateCard?.send();
    await this.entity.updatePartial({
      status: RequestStatusEnum.REQUESTED
    });
    this.close();
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
